(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-variant-swatches"] && !Shopify.designMode) return;
  try {
    (function () {
  const container = document.querySelector('.product-color-variants');
  if (!container) return;
  
  const tooltip = document.getElementById('pcv-swatch-tooltip');
  const tooltipContent = tooltip.querySelector('.pcv-tooltip-content');
  
  let hoverTimeout;
  let currentHoveredElement = null;

  // Enhanced hover interactions
  container.addEventListener('mouseover', function (e) {
    const link = e.target.closest('.pcv-swatch-link');
    if (!link || link === currentHoveredElement) return;
    
    currentHoveredElement = link;
    clearTimeout(hoverTimeout);
    
    const title = link.dataset.swatchTitle || '';
    const price = link.dataset.swatchPrice || '';
    const isActive = link.classList.contains('active');
    
    let tooltipText = `<strong>${title}</strong>`;
    if (price) {
      tooltipText += `<br><span style="opacity: 0.8;">${price}</span>`;
    }
    if (isActive) {
      tooltipText += `<br><span style="color: #16a34a; font-size: 0.75rem;">● Current selection</span>`;
    }
    
    tooltipContent.innerHTML = tooltipText;
    tooltip.classList.add('show');
    tooltip.setAttribute('aria-hidden', 'false');
    
    // Position tooltip relative to hovered element
    const rect = link.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    const leftPosition = rect.left - containerRect.left + (rect.width / 2);
    tooltip.style.left = leftPosition + 'px';
  });

  container.addEventListener('mouseout', function (e) {
    const to = e.relatedTarget;
    if (container.contains(to)) return;
    
    currentHoveredElement = null;
    hoverTimeout = setTimeout(() => {
      tooltip.classList.remove('show');
      tooltip.setAttribute('aria-hidden', 'true');
    }, 150);
  });

  // Enhanced keyboard navigation
  container.addEventListener('keydown', function (e) {
    const links = Array.from(container.querySelectorAll('.pcv-swatch-link'));
    const currentIndex = links.indexOf(document.activeElement);
    
    let nextIndex = -1;
    
    switch (e.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        e.preventDefault();
        nextIndex = currentIndex < links.length - 1 ? currentIndex + 1 : 0;
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        e.preventDefault();
        nextIndex = currentIndex > 0 ? currentIndex - 1 : links.length - 1;
        break;
      case 'Home':
        e.preventDefault();
        nextIndex = 0;
        break;
      case 'End':
        e.preventDefault();
        nextIndex = links.length - 1;
        break;
    }
    
    if (nextIndex !== -1) {
      links[nextIndex].focus();
    }
  });

  // Add loading states for images
  const images = container.querySelectorAll('.pcv-swatch-img');
  images.forEach(img => {
    img.addEventListener('load', function() {
      this.style.animation = 'none';
    });
  });

  // Add smooth scroll behavior when navigating between variants
  const links = container.querySelectorAll('.pcv-swatch-link');
  links.forEach(link => {
    link.addEventListener('click', function(e) {
      // Add a subtle loading state
      this.style.opacity = '0.7';
      setTimeout(() => {
        this.style.opacity = '1';
      }, 200);
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
